import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-titulo-h1',
  templateUrl: './titulo-h1.component.html',
  styleUrls: ['./titulo-h1.component.scss']
})

export class TituloH1Component {
  @Input("titulo") titulo: string;
}
